<template>
  <div>

    <MemberAudienceTable 
      :member="member"
    />
  </div>

</template>

<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';
import { mapGetters } from 'vuex';
import MemberAudienceTable from '@/view/components/member_editor_v2/sections/member_audience/MemberAudienceTable.vue';

export default {

  name: 'MemberAudienceView',

  props: ['member'],
  emits: [],
  mixins: [ toasts ],

  components: {
    MemberAudienceTable
  },

  watch: {
    member: {
      deep: true,
      handler(val) {
        this.local_member = { ...val }
      }
    },


  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
    ...mapGetters(['periods','companies']),

  },


  mounted() {
    if (this.member) {
      this.local_member = {...this.member}
    }

  },

  methods: {


  },


  data() {
    return {
      
      local_member: {}
    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
